import { withProps } from 'recompose';
import createEmotion from 'create-emotion';
import { useMemo } from 'react';

const { flush, css, cache, keyframes, cx } = createEmotion();
export { flush, css, cache, keyframes as animation, cx };

interface StylesDeclaration {
  [key: string]: Style;
}

export interface Style {
  [key: string]: string | number | Style | undefined;
}

type StylesFn<T> = (props: T) => StylesDeclaration;

export type Styles<T> = Record<keyof T, string>;

export interface StylesProps<U extends (...args) => any> {
  styles: Styles<ReturnType<U>>;
}

export default function<T>(fn: StylesFn<T>) {
  return withProps<StylesProps<any>, Omit<T, 'styles'>>(
    (props: T): StylesProps<any> => {
      const styles = fn(props);
      const classnames: any = {};

      for (const key in styles) {
        const rules = styles[key];

        classnames[key] = css(rules);
      }

      return {
        styles: classnames,
      };
    }
  );
}

export const useStyles = <T extends StylesDeclaration>(decl: T) =>
  useMemo((): Styles<T> => {
    const classnames: Styles<T> = {} as any;

    for (const key in decl) {
      const rules = decl[key];

      classnames[key] = css(rules);
    }

    return classnames;
  }, [decl]);
